

























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import TemplateInfoModal from "@/components/templates/modals/TemplateInfoModal.vue";
import TemplateDeleteModal from "@/components/templates/modals/TemplateDeleteModal.vue";
import TemplatePreviewModal from "@/components/templates/modals/TemplatePreviewModal.vue";
// service methods
import { getFilteredTemplates, copyTemplate } from "@/services/templates/templateService";
import { getSolutions } from "@/services/solutions/solutionService";
// types
import { Template, TemplatesFilterDtoIn, TemplateTypeEnum } from "@/services/templates/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { templatesFields } from "@/components/templates/fields/templatesFields";
// css
import "vue-select/dist/vue-select.css";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree,
        "template-info-modal": TemplateInfoModal,
        "template-delete-modal": TemplateDeleteModal,
        "template-preview-modal": TemplatePreviewModal
    }
})
export default class Templates extends Vue {
    // local state
    templates = [] as Array<Template>;
    fields = templatesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // folders
    folderEntity = FolderEntites.Templates;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedSolution = null as Option | any;
    filterWidth = "" as string;
    filterHeight = "" as string;

    // filter options
    solutions = [] as Array<Option>;
    searchText = "" as string;

    // lifecycle hooks
    public created(): void {
        this.fetchData();
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    setTemplateFolderId(data: { entityId: string, folderId: string }) {
        this.templates.forEach((template) => {
            if (template.id === data.entityId) template.folderId = data.folderId;
        });
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    deleteTemplate(templateId: string, name: string) {
        (this.$refs.templateDeleteModal as any).open(templateId, name);
    }

    templateInfo(templateId: string) {
        (this.$refs.templateInfoModal as any).open(templateId);
    }

    updateTemplateRoute(template: Template) {
        if (template.type && template.type === TemplateTypeEnum.sessions) {
            return {
                name: "updateSession",
                params: { sessionTemplateId: template.id }
            };
        } else {
            return {
                name: "updatetemplate",
                params: { templateId: template.id }
            };
        }
    }

    previewTemplate(templateId: string, name: string) {
        (this.$refs.templatePreviewModal as any).open(templateId, name);
    }

    fetchData() {
        this.loadTemplates();
        getSolutions().then(response => {
            this.solutions = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
    }

    loadTemplates() {
        this.isBusy = true;
        this.templates = [] as Array<Template>;
        getFilteredTemplates({
            solutionId: this.selectedSolution ? this.selectedSolution.id : "",
            playerId: ""
        } as TemplatesFilterDtoIn).then(response => {
            this.templates = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedSolution = null;
        this.filterWidth = "";
        this.filterHeight = "";
        this.loadTemplates();
    }

    copyTemplate(id: string) {
        copyTemplate(id).then(() => this.loadTemplates());
    }

    get addTemplate() {
        return {
            name: "createtemplate",
            params: { folderId: this.selectedFolderNode.id }
        };
    }

    // computed and watchers
    get model(): Array<Template> {
        if (this.filterActive) {
            return this.templates.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight)
            );
        } else {
            return this.templates.filter(
                x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
            );
        }
    }

    get filterActive(): boolean {
        return (
            (this.selectedSolution && Object.keys(this.selectedSolution.id).length > 0) ||
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setDragImage(this.$refs["element_" + event.target.getAttribute("entityId")] as any, -10, 0);
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }
}
